var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-game-empty"},[_c('empty-state',{attrs:{"title":"您搜索的商品未在售~","description":"可以尝试更换关键词或浏览其他游戏商品"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }